import { render, staticRenderFns } from "./NoticeDetailModal.vue?vue&type=template&id=9467f1da&scoped=true"
import script from "./NoticeDetailModal.vue?vue&type=script&lang=js"
export * from "./NoticeDetailModal.vue?vue&type=script&lang=js"
import style0 from "./NoticeDetailModal.vue?vue&type=style&index=0&id=9467f1da&prod&lang=scss&scoped=true"
import style1 from "./NoticeDetailModal.vue?vue&type=style&index=1&id=9467f1da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9467f1da",
  null
  
)

export default component.exports